import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { Contact } from '@contacts/interfaces/contact';
import Avatar from 'vue-avatar';
import BpcRouterLink from '@shared/components/bpc-router-link.vue';

library.add(faPlus);
library.add(faIdCard);
library.add(faBook);

@Component({
  name: 'bpc-contact-panel',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    Avatar,
    BpcRouterLink,
  },
})
export default class ContactPanel extends Vue {
  @Prop([String, Number]) readonly contactId: string | number;
  @Prop({ type: String, required: true }) readonly dashboardRoute: string;
  @Prop({ type: Boolean, default: false }) readonly gridView: boolean;
  @Prop(Array) readonly menuContact: any[];

  public entity: Contact = new Contact();
  public entityName = 'contact';
  public pluralEntityName = 'contacts';

  mounted() {
    const path = `${this.$bpcApiRouteHelper.getEntityPath(this.entityName, 'raw')}/${
      this.contactId
    }`;
    this.$bpcApi.get(path).subscribe(res => {
      this.entity = res.data;
    });
  }

  // updated () { }
}
